import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import YukXatiHeader from "../../Components/YukXati/YukXatiHeader";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";

export default function CustomersAdd({ setOpen, open }) {
  const messageApi = useMessage();
  let navigate = useNavigate();

  let createUser = async (values) => {
    try {
      let data = await axiosInstance.post("/api/customers", {
        ...values,
        status: "Активный",
        verify: false,
      });
      if (data?.error) {
        messageApi.open({
          type: "error",
          content: data.message,
        });
        return;
      }

      console.log(data.data);
      setOpen(false);
      navigate("/customers/" + data.data.data.id);
      messageApi.open({
        type: "success",
        content: "Ochildi",
      });
    } catch (error) {
      // setMessage(error.response.data.message);
      if (error?.response?.data?.message) {
        messageApi.open({
          type: "error",
          content: error?.response?.data?.message,
        });
      }
      // console.log(error.response.data.message);
    } finally {
      console.log("true");
    }
  };

  return (
    <>
      {/* <YukXatiHeader /> */}
      <Modal
        style={{ top: "40px", width: "900px" }}
        title="Yangi klient qo'shish!"
        open={open}
        width={800}
        //   loading={loadVagon}
        onOk={() => {
          setOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setOpen(false);
        }}
        footer={[]}
      >
        <div className="  flex flex-col m-auto  justify-center">
          <h1 className="text-2xl text-center">Ro'yxatga olish</h1>
          <Formik
            initialValues={{
              name: "",
              comment: "",
              phone: "",
              type: "",
              INN: "",
            }}
            validationSchema={Yup.object({
              name: Yup.string().required("Yozish shart"),
              INN: Yup.string(),
              type: Yup.string().required("Yozish shart"),
              comment: Yup.string().required("Yozish shart"),
              phone: Yup.string()
                .min(9, "Raqam xato yozildi")
                .max(9, "Raqam xato yozildi")
                .required("Yozish shart shart "),
            })}
            onSubmit={(values) => {
              console.log("values");
              console.log(values);
              createUser(values);
              // handleRegister(values);
            }}
          >
            <Form>
              <label htmlFor="INN">INN</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="INN"
                type="Number"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="INN" />
              </div>
              <label htmlFor="name">Nomi</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="name"
                type="text"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="name" />
              </div>
              <label htmlFor="phone">Tel raqam</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="phone"
                type="number"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="phone" />
              </div>
              {/* type */}
              <label htmlFor="type">Turi</label>
              <Field
                id="type"
                name="type"
                component="select"
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                as="select"
              >
                <option value="">TANLASH</option>
                <option value="MCHJ / FX">MCHJ / FX</option>
                <option value="Brokker">Brokker</option>
                <option value="Shaxs">Shaxs</option>
                <option value="Muhammadjon aka">Muhammadjon aka</option>
                <option value="Do'kon">Do'kon</option>
                <option value="Ombor">Ombor</option>
                <option value="Shaxobcha">Shaxobcha</option>
              </Field>
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="type" />
              </div>
              {/* comment */}
              <label htmlFor="comment">Izox</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="comment"
                as="textarea"
                rows="4"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="comment" />
              </div>
              <br />
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block w-full"
              >
                Submit
              </button>
            </Form>
          </Formik>
        </div>
      </Modal>
    </>
  );
}
